export default __webpack_public_path__ + "static/media/spei.b2a56a10.svg";